import type { ProductConfig } from '../../default/product/product.types';
import type { DeepPartial } from '../../default/types';

export const productConfig: DeepPartial<ProductConfig> = {
  cliplister: {
    customerId: '81856',
  },
  powerSupply: {
    pictogram: {
      included: 'https://bilder.ottoversand.at/i/empiriecom/FuAG_included.svg',
      notIncluded: 'https://bilder.ottoversand.at/i/empiriecom/FuAG_not_included.svg',
      specification: 'https://bilder.ottoversand.at/i/empiriecom/FuAG_specifications.svg',
    },
  },
  ecoFriendlyDelivery: {
    enabled: true,
  },
};
